import React from "react";

import styled from "styled-components";

const InterestedSection = () => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const targetElement = document.getElementById("contact-section");

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth", // This makes the scroll animation smooth
        block: "start" // Aligns the top of the element with the top of the viewport
      });
    } else {
      console.error(`Element with ID '${"contact-section"}' not found.`);
    }
  };

  return (
    <Wrapper id={"interested-section"}>
      <Container>
        <Content>
          <Heading>Interested in Majura?</Heading>
          <ButtonRow>
            <DemoButton onClick={handleClick}>Book a Demo</DemoButton>
            <JobLinkButton href="/careers">Apply for a Job</JobLinkButton>
          </ButtonRow>
        </Content>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  justify-content: center;
  display: flex;
  margin: 200px 0px 100px 0px;

  @media (max-width: 1025px) {
    margin: 65px 0px 50px 0px;
  }
`;

const Container = styled.div`
  background: linear-gradient(to bottom, #d0f1fc 0%, #ffffff 100%);
  border-top-right-radius: 100px;
  border-top-left-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;

  @media (max-width: 767px) {
    width: 100%;
    padding: 0 1rem;
  }
`;

const Content = styled.div`
  text-align: center;
  padding: 100px 0;

  @media (max-width: 1025px) {
    padding: 30px 30px 60px;
  }
`;

const Heading = styled.h2`
  font-size: 3rem;
  color: #0b1c75;
  margin-bottom: 2rem;

  @media (max-width: 1025px) {
    font-size: 2.25rem;
    font-weight: 600;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 60px;
  justify-content: center;
  margin-top: 50px;

  @media (max-width: 1025px) {
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 50px;
    padding: 0 1rem;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BaseButton = styled.button`
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  width: fit-content;
  padding: 1rem 3rem;
  font-size: 1.2rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;

  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 297.81px !important;
  }
`;

const DemoButton = styled(BaseButton)`
  background: #0b1c75;
  color: white;
`;

const ButtonStyleMixin = `
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  width: fit-content;
  padding: 1rem 3rem;
  font-size: 1.2rem;
  display: inline-block;
  box-sizing: border-box;

  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 297.81px !important;
  }
`;

// Now, style the 'a' tag directly
const JobLinkButton = styled.a`
  ${ButtonStyleMixin}
  background: #9d8cff;
  color: white;
  line-height: normal;
  box-shadow: 0 0 0 2px #b3a5ff;

  &:hover {
    color: white;
    opacity: 0.9;
  }
`;

export default InterestedSection;
